import React from "react"
import parse from "html-react-parser"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"
import { graphql } from "gatsby"
import StructuredText from "../custom-structured-text-renderer"
import { useKeenSlider } from "keen-slider/react"

const FoodServiceChef = ({ gallery, richContent, title }) => {
  const [sliderRef] = useKeenSlider({
    loop: true,
    renderMode: "performance",
    drag: true,
    slides: {
      perView: 1.35,
    },
    breakpoints: {
      "(min-width: 768px)": {
        slides: {
          perView: 2.5,
        },
      },
      "(min-width: 1024px)": {
        slides: {
          perView: 3.5,
        },
      },
      "(min-width: 1440px)": {
        slides: {
          perView: 4,
        },
      },
    },
    created(s) {
      //s.moveToIdx(5, true, animation)
    },
    updated(s) {
      //s.moveToIdx(s.track.details.abs + 5, true, animation)
    },
    animationEnded(s) {
      //s.moveToIdx(s.track.details.abs + 5, true, animation)
    },
  })

  return (
    <section className="food-service-chef">
      <div className="food-service-chef__inner">

        <div className="food-service-chef__images keen-slider" ref={sliderRef}>
          {gallery?.length > 0 &&
            gallery.map((el, i) => (
              <div className="food-service-chef__image keen-slider__slide" key={i}>
                <Asset asset={el} />
              </div>
            ))}
            {gallery?.length > 0 &&
            gallery.map((el, i) => (
              <div className="food-service-chef__image keen-slider__slide" key={i}>
                <Asset asset={el} />
              </div>
            ))}
        </div>

        <div className="food-service-chef__content">
          {title && <h2>{parse(title)}</h2>}
          {richContent && <StructuredText data={richContent} />}
        </div>
      </div>
    </section>
  )
}

export default FoodServiceChef

export const query = graphql`
  fragment FoodServiceChefProps on DatoCmsFoodServiceChef {
    ... on DatoCmsFoodServiceChef {
      id
      title
      gallery {
        ...InternalAssetProps
      }
      richContent {
        value
      }
    }
  }
`
